import { Box, styled } from "@mui/material";

export const StyledDarkOverlay = styled(Box)(({ theme }) => ({
  position: "fixed",
  background: "rgba(0, 0,0, 0.7)",
  zIndex: "99",
  width: "100%",
  height: "100%",
  left: "0",
  top: "0",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  ".componentWrapper": {
    background: theme.color.background,
    maxHeight: "80%",
    borderRadius: "25px",
    padding: "3rem",
    position: "relative",
  },
  ".closeBtn": {
    position: "absolute",
    right: "2rem",
    top: "2rem",
    color: theme.color.main,
    cursor: "pointer",
    "&:hover": {
      color: theme.color.contrastColor,
      transition: ".5s",
    },
  },
  [`@media screen and (max-width: ${theme.breakpoints.values.mobile}px)`]: {
    ".componentWrapper": {
      width: "100%",
      borderRadius: "10px",
      padding: "1rem",
      maxHeight: "100%",
      paddingTop: "5rem",
    },
  },
}));
